@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [filterable]="true"
    (filterChange)="filterAcademicPartnerList($event)"
    [data]="AcademicPartnerList"
    [(ngModel)]="AcademicPartners"
    placeholder="Wählen Sie einen Wert aus!"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="form-control"
    textField="name"
    valueField="id"
    [data]="AcademicPartnerList"
    [(ngModel)]="AcademicPartner"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
